import { Flex, Progress, Text } from "@radix-ui/themes";
import { CheckCircledIcon } from "@radix-ui/react-icons";
import { useTranslation } from "react-i18next";

export enum MessageCodes {
  NoItems = "no_items",
  DownwardItems = "downward_items",
  StackedItems = "too_close_or_stacked_items",
  LeanOnItems = "lean_on_items",
  EvaluationCompleted = "evaluation_completed",
  NotFoundItems = "not_found_items",
  CheckoutCompleted = "checkout_completed",
  CheckoutCancel = "checkout_cancel",
}

export function CheckoutStatus({
  isCompleted,
  progressPercentage,
}: {
  isCompleted?: boolean;
  progressPercentage: number;
}) {
  const { t } = useTranslation();

  if (isCompleted) {
    return (
      <div className="gap-3 w-max rounded-t-2xl bg-white p-4 flex items-center">
        <div>
          <CheckCircledIcon width={32} height={32} color="#299764" />
        </div>
        <div>
          <Text
            as="p"
            mb="1"
            weight="medium"
            size="4"
            color="gray"
            highContrast
          >
            {t("processingCompleted")}
          </Text>
          <Text as="p" size="2" color="gray">
            {t("processingCompletedDescription")}
          </Text>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full gap-3 rounded-t-2xl bg-white p-4 items-center">
      <Text as="p" mb="1" weight="medium" size="4" color="gray" highContrast>
        {t("autoCartPendingTitle")}
      </Text>
      <div className="w-full space-y-1">
        <Flex justify="between" align="center" gap="2">
          <Progress value={progressPercentage} duration="20s" />
        </Flex>
      </div>
    </div>
  );
}
